import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import HistoryIcon from '@material-ui/icons/History';
import ListIcon from '@material-ui/icons/List';
import ReservationsTable from './MyReservations/ReservationsTable';
import ReservationsOnHoldTable from './MyOnHoldReservations/ReservationsOnHoldTable';
import ReservationsHistoricalTable from './Historical/ReservationsHistoricalTable';


const styles = theme => ({
  paddingBorder: {
    padding: '16px 200px 0px 200px',
    borderBottom: '2px solid #003341'
  },
  group: {
    display: 'inline-block'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  }
});


class ReservationsPersonal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      historical: false
    }
  }

  detectCancellation = () => {
    this.props.detectCancellation();
  };

  handleClickHistorical = () => {
    this.setState({ historical: !this.state.historical });
  };


  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid container justify='center'>
              <Grid item className={classes.paddingBorder}>
                <Tooltip title={this.state.historical ? 'Ativas' : 'Histórico'} placement='bottom' >
                  <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickHistorical}>
                    {this.state.historical ? <ListIcon /> : <HistoryIcon />}
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {this.state.historical ?
          <ReservationsHistoricalTable newReservation={this.props.newReservation} />
          :
          <React.Fragment>
            <ReservationsTable newReservation={this.props.newReservation} detectCancellation={this.detectCancellation.bind(this)} />
            <ReservationsOnHoldTable newReservation={this.props.newReservation} detectCancellation={this.detectCancellation.bind(this)} />
          </React.Fragment>
        }

      </div>
    );
  }
};

ReservationsPersonal.propTypes = {
  classes: PropTypes.object.isRequired,
  detectCancellation: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(ReservationsPersonal));


// WEBPACK FOOTER //
// ./src/components/Reservations/Personal/ReservationsPersonal.js